import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-horizontal-cards',
  templateUrl: './horizontal-cards.component.html',
  styleUrls: ['./horizontal-cards.component.scss']
})
export class HorizontalCardsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
